// extracted by mini-css-extract-plugin
module.exports = {"button":"_3o8s27i8pcRMQ3cWmGyu5O","cancel":"_3heCncS9pr5BtbV8oC2Bo2","yes":"HBm3cUIwBDOXSIV_jMQ03"};